export default __webpack_public_path__ + "media/images/logo-footer-809943c1e8d29718b818ef8c7110d46c.png";